import { render, staticRenderFns } from "./Share.vue?vue&type=template&id=1ed8d986&"
import script from "./Share.vue?vue&type=script&lang=js&"
export * from "./Share.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Icon/index.vue').default,UiFormField: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Ui/Form/Field.vue').default})
